var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2765 4L28.0005 4.004L28.0031 8.70133L20.7138 15.9893L24.4845 19.7613L26.3711 17.876L28.2565 19.7613L24.9578 23.0613L28.7285 26.8333L26.8431 28.7187L23.0711 24.9467L19.7711 28.2467L17.8858 26.3613L19.7711 24.4747L15.9991 20.704L12.2285 24.4747L14.1151 26.3613L12.2298 28.2467L8.92979 24.9467L5.15779 28.7187L3.27246 26.8333L7.04446 23.06L3.74446 19.7613L5.62979 17.876L7.51513 19.76L11.2845 15.9893L4.00446 8.70933L4.00046 4L8.72846 4.004L15.9991 11.276L23.2765 4ZM13.1698 17.8747L9.40046 21.6453L10.3445 22.588L14.1138 18.8173L13.1711 17.8747H13.1698ZM25.3351 6.668H24.3791L17.8858 13.16L18.8271 14.1027L25.3351 7.59733V6.668ZM6.66846 6.668V7.60133L21.6565 22.5893L22.5991 21.6467L7.62179 6.66933L6.66846 6.668Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwords);
export default __webpack_public_path__ + "static/media/swords.51273def07c73c452f5dc91bd3217924.svg";
export { ForwardRef as ReactComponent };